/**
 * Custom collection shop — multi collection + price filters, AJAX, mobile drawer.
 */
(function () {
  var FILTERS_OPEN_KEY = 'ggShopFiltersOpen';

  function debounce(fn, wait) {
    var t;
    return function () {
      var ctx = this;
      var args = arguments;
      clearTimeout(t);
      t = setTimeout(function () {
        fn.apply(ctx, args);
      }, wait);
    };
  }

  function parseNum(v) {
    var n = parseFloat(String(v).replace(/[^0-9.]/g, ''));
    return isNaN(n) ? 0 : n;
  }

  function isMobileFilters() {
    return window.matchMedia('(max-width: 899px)').matches;
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function init(root) {
    if (!root || root.__ggShopBound) return;
    root.__ggShopBound = true;

    var sectionId = root.getAttribute('data-section-id');
    var allUrl = root.getAttribute('data-all-url') || '/collections/all';
    var moneyFormat = root.getAttribute('data-money-format') || '${{amount}}';
    var collectionChecks = root.querySelectorAll('[data-gg-shop-collection]');
    var sortEl = root.querySelector('[data-gg-shop-sort]');
    var clearBtn = root.querySelector('[data-gg-shop-clear]');
    var priceRoot = root.querySelector('[data-gg-shop-price]');
    var openBtn = root.querySelector('[data-gg-shop-open-filters]');
    var closeBtn = root.querySelector('[data-gg-shop-close-filters]');
    var backdrop = root.querySelector('[data-gg-shop-filters-backdrop]');
    var bannerSection = document.querySelector('.gg-collection-hero');
    var bannerSectionId = null;
    if (bannerSection) {
      var bannerWrap = bannerSection.closest('[id^="shopify-section-"]');
      if (bannerWrap) bannerSectionId = bannerWrap.id.replace(/^shopify-section-/, '');
    }

    var minRange = priceRoot && priceRoot.querySelector('[data-gg-shop-range-min]');
    var maxRange = priceRoot && priceRoot.querySelector('[data-gg-shop-range-max]');
    var minInput = priceRoot && priceRoot.querySelector('[data-gg-shop-input-min]');
    var maxInput = priceRoot && priceRoot.querySelector('[data-gg-shop-input-max]');
    var progress = priceRoot && priceRoot.querySelector('[data-gg-shop-progress]');
    var priceMax = priceRoot ? parseNum(priceRoot.getAttribute('data-max')) : 0;
    var paramMin = priceRoot ? priceRoot.getAttribute('data-param-min') : 'filter.v.price.gte';
    var paramMax = priceRoot ? priceRoot.getAttribute('data-param-max') : 'filter.v.price.lte';

    function setFiltersOpen(open) {
      root.classList.toggle('is-filters-open', !!open);
      document.documentElement.classList.toggle('gg-shop-filters-lock', !!open && isMobileFilters());
      if (openBtn) openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (backdrop) {
        if (open) backdrop.removeAttribute('hidden');
        else backdrop.setAttribute('hidden', '');
      }
      try {
        if (open) sessionStorage.setItem(FILTERS_OPEN_KEY, '1');
        else sessionStorage.removeItem(FILTERS_OPEN_KEY);
      } catch (e) {}
    }

    function openFilters() {
      if (!isMobileFilters()) return;
      setFiltersOpen(true);
    }

    function closeFilters() {
      setFiltersOpen(false);
    }

    function keepFiltersOpen() {
      if (!isMobileFilters()) return;
      try {
        if (sessionStorage.getItem(FILTERS_OPEN_KEY) === '1' || root.classList.contains('is-filters-open')) {
          setFiltersOpen(true);
        }
      } catch (e) {
        if (root.classList.contains('is-filters-open')) setFiltersOpen(true);
      }
    }

    function getSelectedCollections() {
      return Array.prototype.slice.call(root.querySelectorAll('[data-gg-shop-collection]:checked'));
    }

    function syncPriceUI() {
      if (!priceRoot) return;
      var minV = parseNum(minRange.value);
      var maxV = parseNum(maxRange.value);
      if (minV > maxV) {
        if (document.activeElement === minRange) minV = maxV;
        else maxV = minV;
        minRange.value = String(minV);
        maxRange.value = String(maxV);
      }
      minInput.value = String(Math.round(minV));
      maxInput.value = String(Math.round(maxV));
      if (progress && priceMax) {
        var left = (minV / priceMax) * 100;
        var right = (maxV / priceMax) * 100;
        progress.style.left = left + '%';
        progress.style.width = Math.max(0, right - left) + '%';
      }
    }

    function formatMoney(amount) {
      var n = Number(amount);
      if (isNaN(n)) n = 0;
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(Math.round(n * 100), moneyFormat);
      }
      return (
        '$' +
        n.toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })
      );
    }

    function productMinPrice(product) {
      var prices = (product.variants || []).map(function (v) {
        return parseNum(v.price);
      });
      if (!prices.length) return 0;
      return Math.min.apply(null, prices);
    }

    function productMaxPrice(product) {
      var prices = (product.variants || []).map(function (v) {
        return parseNum(v.price);
      });
      if (!prices.length) return 0;
      return Math.max.apply(null, prices);
    }

    function buildUrl(opts) {
      opts = opts || {};
      var selected = opts.selected || getSelectedCollections();
      var base =
        opts.baseUrl ||
        (selected.length === 1 && selected[0].getAttribute('data-url')) ||
        (selected.length > 1 ? allUrl : null) ||
        root.getAttribute('data-collection-url') ||
        allUrl;
      var url = new URL(base, window.location.origin);
      var minV = priceRoot ? parseNum(minInput.value) : 0;
      var maxV = priceRoot ? parseNum(maxInput.value) : priceMax;
      var pristine = priceRoot && minV <= 0 && maxV >= priceMax;

      url.searchParams.delete(paramMin);
      url.searchParams.delete(paramMax);
      url.searchParams.delete('sort_by');
      url.searchParams.delete('page');
      url.searchParams.delete('gg_cols');

      if (!pristine && priceRoot) {
        if (minV > 0) url.searchParams.set(paramMin, String(Math.round(minV)));
        if (maxV < priceMax) url.searchParams.set(paramMax, String(Math.round(maxV)));
      }
      if (sortEl && sortEl.value) url.searchParams.set('sort_by', sortEl.value);
      if (opts.page) url.searchParams.set('page', String(opts.page));
      if (selected.length > 1) {
        url.searchParams.set(
          'gg_cols',
          selected
            .map(function (el) {
              return el.value;
            })
            .join(',')
        );
      }
      return url;
    }

    function replaceSectionHtml(sectionKey, html) {
      if (!html) return;
      var current = document.getElementById('shopify-section-' + sectionKey);
      if (!current) return;
      var wrap = document.createElement('div');
      wrap.innerHTML = html.trim();
      var next = wrap.firstElementChild;
      if (next) current.replaceWith(next);
    }

    function patchResultsFromHtml(sectionHtml) {
      if (!sectionHtml) return;
      var wrap = document.createElement('div');
      wrap.innerHTML = sectionHtml.trim();
      var newShop = wrap.querySelector('[data-gg-shop]');
      if (!newShop) return;
      ['[data-gg-shop-results]', '[data-gg-shop-count]'].forEach(function (sel) {
        var neu = newShop.querySelector(sel);
        var cur = root.querySelector(sel);
        if (neu && cur) cur.replaceWith(neu);
      });
    }

    function updateCount(n) {
      var countEl = root.querySelector('[data-gg-shop-count]');
      if (countEl) countEl.textContent = n + ' PRODUCTS';
    }

    function sortProducts(products, sortBy) {
      var list = products.slice();
      switch (sortBy) {
        case 'price-ascending':
          list.sort(function (a, b) {
            return productMinPrice(a) - productMinPrice(b);
          });
          break;
        case 'price-descending':
          list.sort(function (a, b) {
            return productMinPrice(b) - productMinPrice(a);
          });
          break;
        case 'title-ascending':
          list.sort(function (a, b) {
            return a.title.localeCompare(b.title);
          });
          break;
        case 'title-descending':
          list.sort(function (a, b) {
            return b.title.localeCompare(a.title);
          });
          break;
        case 'created-ascending':
          list.sort(function (a, b) {
            return new Date(a.created_at) - new Date(b.created_at);
          });
          break;
        case 'created-descending':
          list.sort(function (a, b) {
            return new Date(b.created_at) - new Date(a.created_at);
          });
          break;
        default:
          break;
      }
      return list;
    }

    function renderProducts(products) {
      var results = root.querySelector('[data-gg-shop-results]');
      if (!results) return;
      updateCount(products.length);
      if (!products.length) {
        results.innerHTML = '<div class="gg-shop__empty"><p>No products found. Try clearing filters.</p></div>';
        return;
      }
      var html = '<ul class="gg-shop__grid" role="list">';
      products.forEach(function (product) {
        var href = '/products/' + product.handle;
        var img =
          (product.images && product.images[0] && (product.images[0].src || product.images[0])) ||
          product.featured_image ||
          '';
        var img2 =
          (product.images && product.images[1] && (product.images[1].src || product.images[1])) || '';
        var minP = productMinPrice(product);
        var maxP = productMaxPrice(product);
        var priceLabel = minP !== maxP ? 'From ' + formatMoney(minP) : formatMoney(minP);
        var hasSecondary = !!img2;
        html +=
          '<li class="gg-shop__card">' +
          '<a class="gg-shop__card-link' +
          (hasSecondary ? ' gg-shop__card-link--has-secondary' : '') +
          '" href="' +
          escapeHtml(href) +
          '">' +
          '<div class="gg-shop__media">' +
          (img
            ? '<img class="gg-shop__image gg-shop__image--primary" src="' +
              escapeHtml(img) +
              '" alt="' +
              escapeHtml(product.title) +
              '" loading="lazy" width="800" height="800">'
            : '') +
          (hasSecondary
            ? '<img class="gg-shop__image gg-shop__image--secondary" src="' +
              escapeHtml(img2) +
              '" alt="' +
              escapeHtml(product.title) +
              '" loading="lazy" width="800" height="800">'
            : '') +
          '</div>' +
          '<h3 class="gg-shop__card-title">' +
          escapeHtml(product.title) +
          '</h3>' +
          '<p class="gg-shop__card-price">' +
          escapeHtml(priceLabel) +
          '</p>' +
          '</a></li>';
      });
      html += '</ul>';
      results.innerHTML = html;
    }

    function loadSection(urlObj, pushState) {
      if (!sectionId) {
        window.location.href = urlObj.toString();
        return;
      }
      keepFiltersOpen();
      root.classList.add('is-loading');
      var sections = [sectionId];
      if (bannerSectionId) sections.unshift(bannerSectionId);
      var fetchUrl = new URL(urlObj.toString());
      fetchUrl.searchParams.set('sections', sections.join(','));

      fetch(fetchUrl.toString())
        .then(function (r) {
          if (!r.ok) throw new Error('load failed');
          return r.json();
        })
        .then(function (data) {
          if (bannerSectionId && data[bannerSectionId]) {
            replaceSectionHtml(bannerSectionId, data[bannerSectionId]);
          }
          patchResultsFromHtml(data[sectionId]);
          root.classList.remove('is-loading');
          keepFiltersOpen();
          if (pushState !== false) {
            history.pushState({ ggShop: true }, '', urlObj.pathname + urlObj.search);
          }
        })
        .catch(function () {
          window.location.href = urlObj.toString();
        });
    }

    function loadMultiCollections(selected, pushState) {
      keepFiltersOpen();
      root.classList.add('is-loading');
      var urlObj = buildUrl({ selected: selected, baseUrl: allUrl });

      Promise.all(
        selected.map(function (el) {
          var handle = el.value;
          return fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=250')
            .then(function (r) {
              if (!r.ok) throw new Error('products failed');
              return r.json();
            })
            .then(function (data) {
              return data.products || [];
            });
        })
      )
        .then(function (lists) {
          var map = {};
          lists.forEach(function (list) {
            list.forEach(function (product) {
              map[product.id] = product;
            });
          });
          var products = Object.keys(map).map(function (id) {
            return map[id];
          });

          var minV = priceRoot ? parseNum(minInput.value) : 0;
          var maxV = priceRoot ? parseNum(maxInput.value) : priceMax;
          var pristine = priceRoot && minV <= 0 && maxV >= priceMax;
          if (!pristine && priceRoot) {
            products = products.filter(function (product) {
              var price = productMinPrice(product);
              return price >= minV && price <= maxV;
            });
          }

          var sortBy = sortEl ? sortEl.value : '';
          products = sortProducts(products, sortBy);
          renderProducts(products);
          root.classList.remove('is-loading');
          keepFiltersOpen();
          if (pushState !== false) {
            history.pushState({ ggShop: true }, '', urlObj.pathname + urlObj.search);
          }
        })
        .catch(function () {
          root.classList.remove('is-loading');
          keepFiltersOpen();
        });
    }

    function applyCollections(pushState) {
      var selected = getSelectedCollections();
      if (selected.length > 1) {
        loadMultiCollections(selected, pushState !== false);
        return;
      }
      if (selected.length === 1) {
        loadSection(buildUrl({ selected: selected, baseUrl: selected[0].getAttribute('data-url') }), pushState !== false);
        return;
      }
      loadSection(buildUrl({ selected: [], baseUrl: allUrl }), pushState !== false);
    }

    var debouncedPriceLoad = debounce(function () {
      syncPriceUI();
      applyCollections(true);
    }, 450);

    if (openBtn) openBtn.addEventListener('click', openFilters);
    if (closeBtn) closeBtn.addEventListener('click', closeFilters);
    if (backdrop) backdrop.addEventListener('click', closeFilters);

    root.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-filters-open')) closeFilters();
    });

    window.addEventListener('resize', function () {
      if (!isMobileFilters()) closeFilters();
    });

    try {
      if (sessionStorage.getItem(FILTERS_OPEN_KEY) === '1' && isMobileFilters()) {
        setFiltersOpen(true);
      }
    } catch (e) {}

    collectionChecks.forEach(function (input) {
      input.addEventListener('change', function () {
        keepFiltersOpen();
        applyCollections(true);
      });
    });

    if (sortEl) {
      sortEl.addEventListener('change', function () {
        applyCollections(true);
      });
    }

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        collectionChecks.forEach(function (el) {
          el.checked = false;
        });
        if (priceRoot) {
          minRange.value = '0';
          maxRange.value = String(priceMax);
          minInput.value = '0';
          maxInput.value = String(priceMax);
          syncPriceUI();
        }
        if (sortEl && sortEl.options.length) sortEl.selectedIndex = 0;
        keepFiltersOpen();
        applyCollections(true);
      });
    }

    if (priceRoot) {
      ['input', 'change'].forEach(function (evt) {
        minRange.addEventListener(evt, function () {
          syncPriceUI();
          if (evt === 'change') debouncedPriceLoad();
        });
        maxRange.addEventListener(evt, function () {
          syncPriceUI();
          if (evt === 'change') debouncedPriceLoad();
        });
      });
      minInput.addEventListener('change', function () {
        minRange.value = String(parseNum(minInput.value));
        syncPriceUI();
        debouncedPriceLoad();
      });
      maxInput.addEventListener('change', function () {
        maxRange.value = String(parseNum(maxInput.value));
        syncPriceUI();
        debouncedPriceLoad();
      });
      syncPriceUI();
    }

    root.addEventListener('click', function (e) {
      var pageLink = e.target.closest('[data-gg-shop-page]');
      if (!pageLink) return;
      e.preventDefault();
      var href = pageLink.getAttribute('href');
      if (!href) return;
      keepFiltersOpen();
      loadSection(new URL(href, window.location.origin), true);
    });

    // Restore multi-collection from shared URL
    try {
      var colsParam = new URLSearchParams(window.location.search).get('gg_cols');
      if (colsParam) {
        var wanted = colsParam.split(',').filter(Boolean);
        if (wanted.length > 1) {
          collectionChecks.forEach(function (el) {
            el.checked = wanted.indexOf(el.value) !== -1;
          });
          applyCollections(false);
        }
      }
    } catch (e) {}
  }

  function boot() {
    document.querySelectorAll('[data-gg-shop]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
